import { render, staticRenderFns } from "./StartAgainComponent.vue?vue&type=template&id=5b9cebc1"
import script from "./StartAgainComponent.vue?vue&type=script&lang=ts"
export * from "./StartAgainComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports